<template>
  <div class="edit-okr">
    <div class="breadcrumb">
      <a-breadcrumb
        v-show="breadSubTitle"
        separator=">"
      >
        <a-breadcrumb-item>
          <router-link :to="breadTitleLink">
            部门考评
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>{{ breadSubTitle }}</a-breadcrumb-item>
      </a-breadcrumb>
      <!-- <div class="okr-time">
        {{ updateTime }}
      </div> -->
    </div>

    <div
      class="okr-self__info"
    >
      <div class="okr-self__info__title">
        {{ year }}年季度回顾
      </div>
      <div class="okr-self__box">
        <div
          v-if="searchStaffInfo.userName"
          class="userInfo"
        >
          <avatar :src="searchStaffInfo.image" />
          <div>
            <div>
              <span class="okr-self__name">{{ searchStaffInfo.userName }}</span>
              <span class="okr-self__position">{{ searchStaffInfo.duty }}</span>
            </div>
            <div class="okr-self__department">
              {{ searchStaffInfo.department }}
            </div>
          </div>
        </div>
        <div class="okr-self__info__score">
          <dl>
            <dt>Q1</dt>
            <dd>{{ evalData.quarterEvalOne || '-' }}</dd>
          </dl>
          <dl>
            <dt>Q2</dt>
            <dd>{{ evalData.quarterEvalTwo || '-' }}</dd>
          </dl>
          <dl>
            <dt>Q3</dt>
            <dd>{{ evalData.quarterEvalThree || '-' }}</dd>
          </dl>
          <dl>
            <dt>Q4</dt>
            <dd>{{ evalData.quarterEvalFour || '-' }}</dd>
          </dl>
          <dl>
            <dt>年度自评</dt>
            <dd>{{ evalData.selfEvaluateOn271 || '-' }}</dd>
          </dl>
          <dl>
            <dt>年度上级评</dt>
            <dd>{{ evalData.direEvaluateOn271 || '-' }}</dd>
          </dl>
          <dl>
            <dt>年度终评</dt>
            <dd>{{ evalData.yearEvalEnd || '-' }}</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="self-content">
      <div class="score-box">
        <span class="score-title">年度自评</span>
        <span class="score-txt">{{ evalData.selfEvaluateOn271 || '-' }}</span>
      </div>
      <dl>
        <dt>自评总结</dt>
        <dd>
          <pre>{{ evalData.highlightAndWeakness || '-' }}</pre>
        </dd>
      </dl>
    </div>
    <div class="self-content self-margin">
      <div class="score-box">
        <span class="score-title">年度考评</span>
        <span class="score-txt">{{ evalData.direEvaluateOn271 || '-' }}</span>
      </div>
      <dl>
        <dt>考评总结</dt>
        <dd>
          <pre>{{ evalData.direHighlightAndWeakness || '-' }}</pre>
        </dd>
      </dl>
    </div>
    <div
      class="self-content self-margin"
    >
      <dl>
        <dt>年度面谈纪要</dt>
        <dd>
          <pre>{{ evalData.interViewContent || '-' }}</pre>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon, message, Breadcrumb } from 'ant-design-vue'
import Avatar from '@components/avatar/index.vue'

Vue.use(Icon)
Vue.use(Breadcrumb)

export default {
  name: 'YearDireEvaluationDetail',
  components: {
    Avatar,
  },
  data() {
    return {
      evalData: {},
      searchStaffInfo: {},
      breadSubTitle: '',
      breadTitleLink: '',
      updateTime: '',
    }
  },
  async created() {
    const user = this.$route.params.user
    const year = this.$route.params.year
    this.userId = user
    this.year = year
    await this.fetchDireDATa(user, year)
  },
  methods: {
    // 获取年度考评数据
    async fetchDireDATa(user, year) {
      const hide = message.loading('正在加载...')
      try {
        const result = await this.$api.okr.getDEInYearDetail({ userId: user, year })
        // eslint-disable-next-line
        console.log('result', result)
        // todo：几个时间和操作者待渲染
        // this.updateTime = `${result.searchStaffInfo.departmentNameList.userName}于 ${result.updateTime} 提交了自评表`
        const depLength = result.searchStaffInfo.departmentNameList.length
        this.$set(result.searchStaffInfo, 'department', result.searchStaffInfo.departmentNameList[depLength - 1])
        document.title = `${result.searchStaffInfo.userName}的${year}年度考评详情`
        this.breadSubTitle = `${year}年度考评详情 - ${result.searchStaffInfo.userName}`
        this.breadTitleLink = `/direEvaluationList?year=${year}&quarter=0`
        this.$set(this, 'searchStaffInfo', result.searchStaffInfo)
        this.$set(this, 'evalData', result)
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      } finally {
        hide()
      }
    },
  },
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';
.okr-self {
  &__info {
    padding: 20px 32px;
    background-color: @white;

    img {
      margin-right: 8px;
      width: 40px;
      height: 40px;
      border-radius: 40px;
    }
    &__title{font-size: 16px; font-weight: bold; margin-bottom:8px;}
    &__score{display: flex; flex-direction: row; align-items: center; justify-content: center; height:80px; border-radius: 4px;
    dl{margin-bottom: 0; text-align: center;}
    dt{font-size: 12px; color:#999;}
    dt+dd{margin-top: 4px; margin-bottom: 0;}
    dl+dl{margin-left:36px;}}
  }
  &__box{display:flex; flex-direction: row; align-items: center;}
  &__name,
  &__position {
    font-size: @large;
  }
  &__name {
    font-weight: 600;
  }
  &__department {
    color: #999;
    font-size: @small;
  }
}
.userInfo{display: flex; align-items: center; padding-right: 48px; border-right:#eee 1px solid; margin-right: 42px;}
.edit-okr {position: relative;
.breadcrumb{
margin-bottom: 40px;
padding-bottom:16px;
border-bottom: 1px solid #DDD;
}
.okr-time{
position:absolute;
right: 0;
top:38px;
height: 40px;
line-height: 40px;
font-size:13px;
color:#ccc;
}
}
.self-content{padding: 0 32px 20px; background-color: @white;
dl{padding-top: 16px; font-size: 14px; margin-bottom: 0;}
dt{margin-bottom: 8px;}
dd,pre{margin-bottom: 0; white-space: pre-wrap;}
}
.score-box{display: flex; flex-direction: row; align-items: center;}
.score-title{font-size: 16px; font-weight: bold;}
.score-txt{font-size: 24px; font-weight: bold; color: @blue; padding-left: 8px;}
.self-margin{margin-top:20px; border-radius: 4px; padding-top: 20px;}
</style>
